import { useBrandAccent } from './chunk-E4NIZZY2.js';
import { cn } from '@authe/ui-core';
import { jsx } from 'react/jsx-runtime';

function ProtocolIcon({ protocolId, icon: Icon, className }) {
  const accent = useBrandAccent(protocolId);
  return /* @__PURE__ */ jsx(Icon, { className: cn("size-4 shrink-0", accent.text, className), "aria-hidden": true });
}

export { ProtocolIcon };
//# sourceMappingURL=chunk-IVKBUXNO.js.map
//# sourceMappingURL=chunk-IVKBUXNO.js.map